import { PDFJob } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreatePDFJobArgs,
    getDefaultPDFJobCreateArgs,
    UpdatePDFJobArgs,
} from "@nova/serializer/src/client/validators/jobs/pdf"
import { selectActivatedFireId } from "features/map/control/selectors"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import {
    addEntitySocket,
    deleteEntitySocket,
    updateEntitySocket,
} from "features/entity-caching/project/slice"
import { AnyAction } from "@nova/constants"
import { selectUserID } from "user/profile/selectors"

const {
    create: createPDFJob,
    update: updatePDFJob,
    delete: deletePDFJob,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    PDFJob, // entity type
    CreatePDFJobArgs, // create args to send to server
    ["name", "id"], // create args required by action
    UpdatePDFJobArgs, // update args
    void, // path required to find entity
    {
        callerId: string
        portfolioId: string
        fireId: string
    }
>("PDFJob")

export const addPDFJobsToBuilder = (builder: Builder) =>
    builder
        .addCase(
            createAction,
            (
                store,
                {
                    payload: {
                        data: { name, id },
                    },
                },
                socket
            ) => {
                const state = store.getState()
                const userId = selectUserID(state)!
                const projectId = selectActivatedFireId(state)!
                const orgId = selectActiveWorkspaceId()(state)!
                const context = {
                    callerId: projectId,
                    portfolioId: orgId,
                    fireId: projectId,
                    jobId: id,
                }
                const data = {
                    name,
                    id,
                    ...getDefaultPDFJobCreateArgs(state.project.data),
                    createdBy: { userId },
                }
                createPDFJob(socket, data, context)
                store.dispatch(
                    addEntitySocket({
                        data,
                        path: ["PDFs"],
                    })
                )
            }
        )
        .addCase(updateAction, (store, { payload: { id, updates } }, socket) => {
            updatePDFJob(socket, id, updates, {
                callerId: "",
                portfolioId: "",
                fireId: "",
            })
            store.dispatch(updateEntitySocket({ updates, path: ["PDFs", { id }] }))
        })
        .addCase(deleteAction, (store, { payload: { id } }, socket) => {
            // prototodo: fix this type
            deletePDFJob(socket, id, {} as AnyAction)
            store.dispatch(
                deleteEntitySocket({
                    path: ["PDFs", { id }],
                })
            )
        })

export { createAction as createPDFJob, updateAction as updatePDFJob, deleteAction as deletePDFJob }
